'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@components/typography';
import { faqs } from './faqs-data';
export const FaqsSection: React.FC = () => {
  const $ = _c(8);
  const [openIndex, setOpenIndex] = React.useState(null);
  let t0;
  if ($[0] !== openIndex) {
    t0 = index => {
      setOpenIndex(openIndex === index ? null : index);
    };
    $[0] = openIndex;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleQuestion = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="title4" component="h2" className="text-center !text-3xl sm:!text-4xl lg:!text-5xl mb-10">FAQs</Typography>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== openIndex || $[4] !== toggleQuestion) {
    t2 = faqs.map((item, index_0) => {
      const isOpen = openIndex === index_0;
      return <div key={item.id} className="bg-off-white rounded-xl overflow-hidden transition-all duration-300"><button type="button" id={`faq-trigger-${item.id}`} className="w-full py-5 px-6 flex justify-between items-center text-left" onClick={() => toggleQuestion(index_0)} aria-expanded={isOpen} aria-controls={`faq-panel-${item.id}`}><Typography component="h3" variant="body1" className="!font-semibold text-primary-main pr-4">{item.question}</Typography><FontAwesomeIcon icon={faChevronDown} className={`text-primary-main h-4 w-4 flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} /></button><div id={`faq-panel-${item.id}`} role="region" aria-labelledby={`faq-trigger-${item.id}`} aria-hidden={!isOpen} className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-[500px]" : "max-h-0"}`}><div className="px-6 pb-5"><Typography component="p" variant="body1" className="text-primary-main/80 leading-relaxed whitespace-pre-line">{item.answer}</Typography></div></div></div>;
    });
    $[3] = openIndex;
    $[4] = toggleQuestion;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="bg-white w-full"><div className="max-w-4xl mx-auto px-4 sm:px-8 py-12 sm:py-16 text-primary-main">{t1}<div className="flex flex-col gap-3">{t2}</div></div></div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};